import { Icon } from '../Icon/Icon';
import { type LazyLoaderProps } from './Lazyloader.types';

export const Lazyloader = (props: LazyLoaderProps) => {
    if (!props.image) {
        return null;
    }

    const { imageUrl, aspectRatio, altText, lowresBase64 } = props.image;
    const { disableLazyLoad, useFullSizeVersion } = props;
    const src = props.image.src ?? imageUrl;
    const loading = props.image.loading ?? (disableLazyLoad ? 'eager' : 'lazy');
    const sizes = props.image.sizes ?? (loading === 'lazy' ? 'auto, 100vw' : '100vw');
    const width = props.image.renderedWidth ?? props.image.imageWidth;
    const height = props.image.renderedHeight ?? props.image.imageHeight;
    const modalId = imageUrl ? 'lazyloader-modal-' + imageUrl.substring(imageUrl.lastIndexOf('/') + 1).replace(/\./g, '-') : null;
    const containerStyle = {
        aspectRatio: aspectRatio?.toString(),
        backgroundImage: lowresBase64 ? `url('${lowresBase64}')` : undefined,
    };
    const fetchPriority = props.image.fetchPriority ? { fetchPriority: props.image.fetchPriority } : {};

    return (
        <>
            <span
                style={containerStyle}
                className={`d-block lazyloader responsive-image ${props.isBackgroundImage ? 'lazyloader--background' : ''} ${
                    props.hasVideo ? 'hasVideo' : ''
                }`}
                data-responsive-image
            >
                <img
                    className="lazyloader__image responsive-image__image"
                    src={src}
                    srcSet={props.image.srcSet}
                    sizes={sizes}
                    width={width}
                    height={height}
                    loading={loading}
                    decoding="async"
                    alt={altText ?? ''}
                    {...fetchPriority}
                />
                {imageUrl && useFullSizeVersion && (
                    <button
                        type="button"
                        className="position-absolute lazyloader__expand-button p-1"
                        data-bs-toggle="modal"
                        data-bs-target={`#${modalId}`}
                    >
                        <Icon className="lazyloader__expand-button-icon" symbol="icon-expand" />
                        <span className="visually-hidden">Förstora bild</span>
                    </button>
                )}
                {props.hasVideo ? <span className="d-block play-button"></span> : null}
            </span>
            {imageUrl && useFullSizeVersion && (
                <span className="modal fade" id={modalId} tabIndex={-1} role="dialog">
                    <span className="modal-dialog modal-xl modal-dialog-centered responsive-image__modal-dialog">
                        <span className="modal-content overflow-hidden responsive-image__modal-content">
                            <img
                                src={props.image.expandedSrc ?? imageUrl}
                                srcSet={props.image.expandedSrcSet}
                                sizes="90vw"
                                loading="lazy"
                                decoding="async"
                                alt={altText ?? ''}
                                className="responsive-image__expanded"
                            />
                            <button
                                type="button"
                                className="close position-absolute lazyloader__close-btn border-0"
                                data-bs-dismiss="modal"
                                aria-label="Stäng"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </span>
                    </span>
                </span>
            )}
        </>
    );
};
